var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09429 1.57276L7.09428 1.57274C7.01836 1.20398 6.6579 0.983433 6.28732 1.10692C6.28729 1.10693 6.28726 1.10694 6.28723 1.10695L1.28772 2.76682C0.93629 2.8835 0.715723 3.26553 0.790394 3.62822C0.867842 4.0044 1.23233 4.21484 1.59684 4.09382L5.00288 2.96299L0.254237 11.1879C0.0661188 11.5137 0.136178 11.9424 0.460898 12.1299C0.785619 12.3174 1.19192 12.1637 1.38004 11.8379L6.12869 3.61298L6.85238 7.12811C6.92983 7.50429 7.29432 7.71473 7.65883 7.59371C8.01026 7.47703 8.23082 7.09501 8.15616 6.73232C8.15616 6.73232 8.15616 6.73231 8.15616 6.73231L7.09429 1.57276Z",
    fill: "#1FAC48",
    stroke: "#1FAC48",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonal);
export default __webpack_public_path__ + "static/media/diagonal.4135b8dfa7160e74b8328b075667c50f.svg";
export { ForwardRef as ReactComponent };